/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2ArrowDown/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2ArrowDown({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2ArrowDown",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 11,
  height = 10,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2ArrowDown.Svg"
  data-view-path={viewPath}
 viewBox="0 0 11 10"
 style={{'--as-1-1kvSNW': alignSelf,'--mt-2-1kvSNW': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1kvSNW': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1kvSNW': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1kvSNW': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1kvSNW': opacity,'--w-10-1kvSNW': typeof width === 'number' ? `${width}px` : width,'--h-11-1kvSNW': typeof height === 'number' ? `${height}px` : height,'--f-12-1kvSNW': fill,'--a-7-1kvSNW': isAnimated ? animation : "none",'--sd-8-1kvSNW': isAnimated ? strokeDashoffset : 0,'--sd-9-1kvSNW': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<g
  data-testid="Tysiav2ArrowDown.SvgGroup"
  data-view-path={viewPath}
 clipPath="url(#clip0_2176_4001)"
 transform="rotate(90 5.5 5)"
 className="views-block"
>
<path
  data-testid="Tysiav2ArrowDown.SvgPath"
  data-view-path={viewPath}
 d="M4.786.357a.357.357 0 01.61-.252l4.382 4.39a.7.7 0 010 1.01l-4.382 4.39a.357.357 0 01-.61-.252V.357z"
 style={{'--f-12-1kvSNW': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</g>
</svg>
{children}
</React.Fragment>)
}